export enum Role {
	UZIVATEL_SUBJEKTU = 'UZIVATEL_SUBJEKTU',
	ADMINISTRATOR_SUBJEKTU = 'ADMINISTRATOR_SUBJEKTU'
}
